const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * User Proliferation Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Proliferation', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {

  return $resource(appConfiguration.apiUrl + '/learn/v3/proliferation/:resource', null, {
    edit: {params: {resource: 'pre-final-edit'}, method: 'POST'},
    final: {params: {resource: 'final'}, method: 'POST'}
  });

}]);